import { useMemo } from 'react';

import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';
import { toTengePrice } from '@/services/helpers/strings';

import type { TBccBankOffer } from '../../../types/bcc.types';

interface IProps {
  bankOffer: TBccBankOffer;
  offerDetailsModal: boolean | string;
}

const useAdditionalHelpers = ({ bankOffer, offerDetailsModal }: IProps) => {
  const additionalProducts = useMemo(() => {
    const products = {
      title: 'Доп. продукты',
      content: [] as string[]
    };

    if (bankOffer.insuranceAmount) {
      products.content.push(`КАСКО ${toTengePrice(bankOffer.insuranceAmount)}`);
    }

    const responseApprovedBody = bankOffer.responseApprovedBody;
    if (responseApprovedBody && checkIsValidJSON(responseApprovedBody)) {
      const parsed: { isBccPayHolder?: 0 | 1 } =
        JSON.parse(responseApprovedBody);
      if (parsed.isBccPayHolder === 1) {
        products.content.push('Подарок по акции Jetour от BCC');
      }
    }

    return products;
  }, [bankOffer.insuranceAmount, bankOffer.responseApprovedBody]);

  const getDescription = (): string => {
    if (typeof offerDetailsModal === 'string') return offerDetailsModal;

    const bankDescription: string = bankOffer.bankDescription || '';

    const isValidJSON = checkIsValidJSON(bankDescription);

    if (!isValidJSON) return bankDescription;

    try {
      return JSON.stringify(JSON.parse(bankDescription), null, 2);
    } catch {
      return bankDescription;
    }
  };

  return { additionalProducts, getDescription };
};

export default useAdditionalHelpers;
